<!--
  SettlementMockBadge.vue
  콜봇 월 정산 · 헤더의 `목 데이터` 배지(내선 관리 `?pbxMock=1` 의 ext-view__mock 과 같은 모양).

  요청: ~/md/front/admin-콜봇-월정산-프론트요청.md "결론 먼저 7" — `?settlementMock=1`(production 이 아닐
  때만) 목으로 도는 동안 헤더에 `목 데이터` 배지를 보인다.

  - 보일지는 부모가 정한다: `<SettlementMockBadge v-if="mock">` (mock = isSettlementMockEnabled()).
    이 컴포넌트는 목 스위치를 읽지 않는다.
  - 기본 슬롯: 개발용 조작(마감 상태 고르기·대사 장면·자동 마감 켜기/끄기 등)을 배지 옆 점선 칸 안에
    그린다. 슬롯이 비면 배지만 보인다.
-->
<template>
  <span class="mock-badge">
    <span class="mock-badge__label" :title="MOCK_TITLE">목 데이터</span>
    <span v-if="$slots.default" class="mock-badge__controls" role="group" aria-label="목 데이터 조작(개발용)">
      <slot />
    </span>
  </span>
</template>

<script setup>
const MOCK_TITLE = 'DEV ?settlementMock=1 — 서버에 요청하지 않습니다';
</script>

<style scoped lang="scss">
@use '../styles/settlement' as *;

.mock-badge {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  &__label {
    padding: 2px 8px;
    border-radius: 6px;
    background: $st-warning-bg;
    color: $st-warning;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    cursor: help;
  }

  // 개발용 조작은 실제 화면 요소와 헷갈리지 않게 점선으로 묶는다
  &__controls {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 8px;
    padding: 2px 8px;
    border: 1px dashed $st-warning-border;
    border-radius: 8px;
    background: #fffdf8;
    font-size: 12px;
    color: $st-text-secondary;
  }
}
</style>
